import { render, staticRenderFns } from "./LoVotesList.vue?vue&type=template&id=0a02f958&scoped=true"
import script from "./LoVotesList.vue?vue&type=script&lang=js"
export * from "./LoVotesList.vue?vue&type=script&lang=js"
import style0 from "./LoVotesList.vue?vue&type=style&index=0&id=0a02f958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02f958",
  null
  
)

export default component.exports